import { Component, useCallback, useSyncExternalStore } from 'react'

// One crashing plugin component must not take the app down: every slot
// contribution renders inside its own boundary and degrades to a small chip.
class ContributionBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    console.error(
      `[omni] slot component from "${this.props.pluginId}" crashed`,
      error
    )
  }

  render() {
    if (this.state.error) {
      return (
        <span
          className="badge badge-error badge-sm"
          title={String(this.state.error)}
        >
          ⚠ {this.props.pluginId ?? 'plugin'}
        </span>
      )
    }
    return this.props.children
  }
}

export function Slot({ name, registry, className }) {
  const contributions = useSyncExternalStore(
    useCallback(
      (cb) => {
        const d = registry.subscribe(name, cb)
        return () => d.dispose()
      },
      [registry, name]
    ),
    () => registry.getContributions(name)
  )
  if (contributions.length === 0) return null
  return (
    <div className={className} data-slot={name}>
      {contributions.map(({ component: C, key, pluginId }) => (
        <ContributionBoundary key={key} pluginId={pluginId}>
          <C />
        </ContributionBoundary>
      ))}
    </div>
  )
}
